export const translations = {
  en: {
    nav: {
      about: "About",
      story: "Story",
      products: "Products",
      markets: "Markets",
      values: "Values",
      faq: "FAQ",
      contact: "Contact",
      whatsapp: "WhatsApp",
      language: "Language",
    },
    hero: {
      since: "Vasavi Gold · Since 1975",
      headlineLine1: "Premium Rice,",
      headlineLine2: "Trusted for",
      headlineLine3: "Every Grain.",
      subtitle: "Gupta Enterprises is committed to delivering premium-quality rice through trust, consistency, and excellence.",
      whatsappBtn: "WhatsApp Us",
      callBtn: "Call Us",
      enquiryBtn: "Business Enquiry",
      scroll: "Scroll",
    },
    about: {
      eyebrow: "Our Heritage",
      title: "Traditional values,",
      titleHighlight: "modern excellence.",
      desc1: "The legacy established by S. V. N. Gupta in 1975 has been proudly carried forward by S. V. V. S. N. Gupta, who transformed the family business into Gupta Enterprises.",
      desc2: "Today, under the Vasavi Gold brand, the company represents a perfect blend of traditional values and modern business practices — delivering premium-quality rice with consistency, reliability, and excellence.",
      badgeTitle: "Gupta Family Guarantee",
      badgeDesc: "More than five decades of experience, dedication, and trust earned from generations of customers.",
      tag1: "50+ Years Legacy",
      tag2: "S. V. N. Gupta Heritage",
      tag3: "Pure & Premium",
    },
    story: {
      eyebrow: "Our Journey",
      title: "Five decades of",
      titleHighlight: "quality and trust.",
      subtitle: "A compelling story of a family business evolving into Gupta Enterprises and the Vasavi Gold brand.",
      t1Year: "1975",
      t1Title: "The Beginning",
      t1Desc: "The family's journey in the rice business began under the leadership of S. V. N. Gupta.",
      t2Year: "Transition",
      t2Title: "Leadership Transition",
      t2Desc: "S. V. V. S. N. Gupta carried forward the family legacy, expanding and modernizing the business.",
      t3Year: "Today",
      t3Title: "Gupta Enterprises & Vasavi Gold",
      t3Desc: "The business proudly operates as Gupta Enterprises, delivering premium-quality rice under the Vasavi Gold brand.",
      t4Year: "Future",
      t4Title: "Expanding Horizons",
      t4Desc: "Continuing a legacy of excellence while expanding our presence across India and international markets.",
    },
    whyChoose: {
      eyebrow: "Why Vasavi Gold",
      title: "Why businesses & families",
      titleHighlight: "choose Vasavi Gold.",
      subtitle: "We combine traditional trust with modern grain sorting standards.",
      c1Title: "Better Quality",
      c1Desc: "Every batch is carefully sorted and graded to meet a premium standard you can trust.",
      c2Title: "Affordable Prices",
      c2Desc: "Premium rice priced fairly — exceptional quality without the premium markup.",
      c3Title: "Fast Delivery",
      c3Desc: "Reliable, timely dispatch that keeps your shelves and kitchens always stocked.",
      c4Title: "Honest Business",
      c4Desc: "Transparent dealings and consistent grades. What we promise is what you receive.",
      c5Title: "Wide Product Range",
      c5Desc: "From Sona Masoori to Idli rice — one dependable source for every requirement.",
      c6Title: "Personalized Service",
      c6Desc: "A family business that knows its customers by name and serves them personally.",
      c7Title: "Strong Dealer Network",
      c7Desc: "Long-term partnerships built on reliability, fair pricing and mutual growth.",
    },
    products: {
      eyebrow: "Our Product Range",
      title: "Premium rice for",
      titleHighlight: "every table & requirement.",
      lowGiName: "Low GI Rice (Diabetic-Friendly)",
      lowGiTag: "Diabetic Friendly · Low GI",
      lowGiDesc: "Gupta's Vasavi Gold Non-GMO White Rice with Low Glycemic Index. Good for general health, naturally seasoned aged rice with original fragrance and traditional taste.",
      lowGiBadge: "Diabetic Friendly · 1kg",
      riceRavvaName: "Premium Rice Ravva",
      riceRavvaTag: "Double Silky & Sortexed",
      riceRavvaDesc: "Gupta's Vasavi Gold Premium Rice Ravva. Double silky and sortexed for tasty, crunchy, and delicious upma, kudumulu, and traditional recipes.",
      bangaruName: "Bangaru Theegalu (Golden Long Rice)",
      bangaruTag: "Sweet Taste & Aroma · 26kg",
      bangaruDesc: "VG Rice Bangaru Theegalu Golden Long Rice packed by Gupta Enterprises. Premium quality long-grain rice with sweet taste and lingering aroma.",
      ayodhyaName: "Ayodhya Sortex HMT Rice",
      ayodhyaTag: "Ayodhya Ramudu Grade · 26kg",
      ayodhyaDesc: "Ayodhya Sortex HMT Rice packed & marketed by Gupta Enterprises. Fine, clean, 100% sortexed grains ideal for daily meals and family feasts.",
      idlyRavvaName: "Vasavi Gold Idly Ravva",
      idlyRavvaTag: "Soft & Fluffy Idli Mix · 26kg",
      idlyRavvaDesc: "Gupta's Vasavi Gold Premium Quality Idly Ravva. 100% natural, authentic taste with no artificial colours for soft, fluffy idlis.",
      superiorSortexName: "Vasavi Gold Sortex Superior Quality Rice (Blue Pack)",
      superiorSortexTag: "100% Natural Aromatic · 26kg",
      superiorSortexDesc: "Gupta's Vasavi Gold Sortex Superior Quality Rice in signature royal blue 26kg bag. 100% natural aromatic grains, guaranteed purity, and great traditional taste.",
      greenSortexName: "Vasavi Gold Sortex Superior Quality Rice (Green Pack)",
      greenSortexTag: "100% Natural Aromatic · 26kg",
      greenSortexDesc: "Gupta's Vasavi Gold Sortex Superior Quality Rice in iconic emerald green 26kg bag. 100% natural aromatic grains, guaranteed purity, and authentic traditional taste.",
      maroonSortexName: "Vasavi Gold Sortex Superior Quality Rice (Maroon Pack)",
      maroonSortexTag: "100% Natural Aromatic · 26kg",
      maroonSortexDesc: "Gupta's Vasavi Gold Sortex Superior Quality Rice in rich maroon 26kg bag. 100% natural aromatic grains, guaranteed purity, and exquisite traditional taste.",
      sonaName: "Sona Masoori",
      sonaTag: "Everyday Premium",
      sonaDesc: "Lightweight, aromatic and easy to digest — the beloved everyday table rice of South India.",
      steamName: "Steam Rice",
      steamTag: "Soft & Fluffy",
      steamDesc: "Parboiled and steam-processed for fluffy, non-sticky grains that hold their shape beautifully.",
      rawName: "Raw Rice",
      rawTag: "Pure & Natural",
      rawDesc: "Naturally milled raw rice retaining its wholesome texture, aroma and authentic flavour.",
      premName: "Premium Rice",
      premTag: "Signature Grade",
      premDesc: "Our finest, hand-selected long grains reserved for the most discerning kitchens.",
      idliName: "Idli Rice",
      idliTag: "Soft Fermentation",
      idliDesc: "Specially suited for idli and dosa batters — soft, absorbent and perfectly fermenting.",
      brokenName: "Broken Rice",
      brokenTag: "Value Choice",
      brokenDesc: "Economical broken grains ideal for porridge, batters and high-volume kitchens.",
      enquireBtn: "Enquire for Bulk Order",
    },
    markets: {
      eyebrow: "Wholesale & Retail",
      title: "Serving partners",
      titleHighlight: "across the spectrum.",
      subtitle: "From single bag buyers to container bulk exporters, we deliver with equal dedication.",
      m1: "Retail Shops",
      m2: "Dealers",
      m3: "Distributors",
      m4: "Supermarkets",
      m5: "Hotels & Restaurants",
      m6: "Export Buyers",
      m7: "Individual Customers",
    },
    stats: {
      eyebrow: "Gupta Enterprises in Numbers",
      title: "Numbers that reflect",
      titleHighlight: "our commitment.",
      s1Label: "Years of Legacy",
      s2Label: "Product Categories",
      s3Label: "Happy Business Partners",
      s4Label: "Growing Customer Base",
    },
    mission: {
      eyebrow: "Mission & Vision",
      missionTitle: "Our Mission",
      missionDesc: "To build lasting relationships through exceptional quality, honest business practices, and a commitment to excellence.",
      visionTitle: "Our Vision",
      visionDesc: "To position Vasavi Gold as a trusted household brand across India and international markets while continuing our legacy of excellence.",
    },
    manifesto: {
      eyebrow: "Brand Manifesto",
      title: "The Vasavi Gold Promise",
      m1Title: "Every grain, considered.",
      m1Desc: "We treat rice as the heart of the meal — sorting, grading and packing each batch with the care a family gives its own table.",
      m2Title: "Trust, earned daily.",
      m2Desc: "Consistency is our craft. The quality you receive today is the quality you will receive next season, and the season after.",
      m3Title: "A legacy in the making.",
      m3Desc: "Carried forward from S. V. N. Gupta to S. V. V. S. N. Gupta, Vasavi Gold represents 50+ years of family dedication.",
    },
    values: {
      eyebrow: "Core Values",
      title: "The principles that",
      titleHighlight: "guide everything we do.",
      v1Title: "Integrity",
      v1Desc: "We do honest business, always.",
      v2Title: "Quality",
      v2Desc: "Premium grade, batch after batch.",
      v3Title: "Trust",
      v3Desc: "Relationships that last generations.",
      v4Title: "Customer Satisfaction",
      v4Desc: "Your kitchen, our commitment.",
      v5Title: "Growth",
      v5Desc: "Growing together with our partners.",
      v6Title: "Innovation",
      v6Desc: "Better sourcing, smarter service.",
    },
    faq: {
      eyebrow: "Frequently Asked Questions",
      title: "Have questions?",
      titleHighlight: "We have answers.",
      subtitle: "Everything you need to know about purchasing, bulk orders, and dealership.",
      q1: "What products do you distribute?",
      a1: "We distribute a premium range of rice under the Vasavi Gold brand — Sona Masoori, Steam Rice, Raw Rice, Premium Rice, Idli Rice and Broken Rice.",
      q2: "Do you supply bulk orders?",
      a2: "Yes. We specialise in bulk supply for retailers, distributors, supermarkets, hotels and restaurants. Share your requirement through the enquiry form and our team will respond promptly.",
      q3: "How can dealers contact you?",
      a3: "Dealers and distributors can reach us directly on WhatsApp or phone, or submit a Business Enquiry using the form below. We love building long-term dealer relationships.",
      q4: "Do you support export enquiries?",
      a4: "Absolutely. We welcome export buyers and are actively growing the Vasavi Gold brand in global markets. Mention 'Export' in your enquiry and we'll get in touch.",
      q5: "Can businesses request quotations?",
      a5: "Yes. Send us your product, quantity and delivery location via the enquiry form or WhatsApp, and we'll share a competitive quotation.",
    },
    contact: {
      eyebrow: "Business Enquiry",
      title: "Let's build something",
      titleHighlight: "lasting together.",
      subtitle: "Dealers, distributors, bulk buyers and export partners — reach out and our family will personally get back to you.",
      visitUs: "Visit Us",
      callUs: "Call Us",
      emailUs: "Email Us",
      chatWhatsapp: "Chat on WhatsApp",
      formTitle: "Send us an enquiry",
      formSubtitle: "We usually respond within one business day.",
      nameLabel: "Full Name *",
      namePlaceholder: "Your name",
      phoneLabel: "Phone *",
      phonePlaceholder: "+91 ...",
      emailLabel: "Email *",
      emailPlaceholder: "you@email.com",
      companyLabel: "Company (optional)",
      companyPlaceholder: "Business name",
      typeLabel: "Enquiry Type",
      msgLabel: "Message *",
      msgPlaceholder: "Tell us about your requirement — product, quantity and delivery location.",
      submitBtn: "Submit Enquiry",
      submittingBtn: "Sending…",
      submittedBtn: "Enquiry Sent",
    },
    footer: {
      brandDesc: "Carrying forward a 50+ year legacy established by S. V. N. Gupta into Gupta Enterprises — delivering Vasavi Gold premium rice with trust and excellence.",
      quickLinks: "Quick Links",
      contactTitle: "Contact Info",
      rights: "All rights reserved.",
      address: "Chemudulanka, Dr. B. R. Ambedkar Konaseema District, Andhra Pradesh 533234",
    },
  },
  te: {
    nav: {
      about: "మా గురించి",
      story: "మా చరిత్ర",
      products: "రకాలు & ఉత్పత్తులు",
      markets: "మార్కెట్లు",
      values: "విలువలు",
      faq: "సందేహాలు (FAQ)",
      contact: "సంప్రదించండి",
      whatsapp: "వాట్సాప్",
      language: "భాష",
    },
    hero: {
      since: "వాసవి గోల్డ్ · 1975 నుండి సంప్రదాయం",
      headlineLine1: "నాణ్యమైన బియ్యం,",
      headlineLine2: "ప్రతి గింజలో",
      headlineLine3: "నమ్మకం.",
      subtitle: "గుప్తా ఎంటర్‌ప్రైజెస్ నమ్మకం, స్థిరమైన నాణ్యత మరియు ప్రతి గింజలో శ్రేష్ఠతతో అత్యుత్తమ బియ్యాన్ని మీకు అందిస్తోంది.",
      whatsappBtn: "వాట్సాప్‌లో మెసేజ్ చేయండి",
      callBtn: "ఫోన్ చేయండి",
      enquiryBtn: "వ్యాపార విచారణ",
      scroll: "క్రిందికి చూడండి",
    },
    about: {
      eyebrow: "మా సంప్రదాయం",
      title: "సంప్రదాయ విలువలు,",
      titleHighlight: "ఆధునిక నాణ్యత.",
      desc1: "1975లో ఎస్. వి. ఎన్. గుప్తా గారు ప్రారంభించిన పటిష్టమైన వారసత్వాన్ని ఎస్. వి. వి. ఎస్. ఎన్. గుప్తా గారు ముందుకు తీసుకెళ్లి, ఈ కుటుంబ వ్యాపారాన్ని 'గుప్తా ఎంటర్‌ప్రైజెస్‌'గా మలిచారు.",
      desc2: "నేడు, ఈ సంస్థ సంప్రదాయ విలువలు మరియు ఆధునిక పద్ధతుల అద్భుత కలయికగా నిలిచింది. వాసవి గోల్డ్ బ్రాండ్‌తో అత్యుత్తమ నాణ్యమైన బియ్యాన్ని స్థిరమైన నమ్మకంతో మీకు అందిస్తున్నాము.",
      badgeTitle: "గుప్తా కుటుంబ హామీ",
      badgeDesc: "ఐదు దశాబ్దాలకు పైగా అనుభవం, నిబద్ధత మరియు తరతరాల కస్టమర్ల నమ్మకం.",
      tag1: "50+ ఏళ్ల సంప్రదాయం",
      tag2: "ఎస్. వి. ఎన్. గుప్తా వారసత్వం",
      tag3: "శుద్ధమైన నాణ్యత",
    },
    story: {
      eyebrow: "మా ప్రయాణం",
      title: "ఐదు దశాబ్దాల పటిష్టమైన",
      titleHighlight: "నాణ్యత మరియు నమ్మకం.",
      subtitle: "కుటుంబ వ్యాపారం నుండి గుప్తా ఎంటర్‌ప్రైజెస్ మరియు వాసవి గోల్డ్ బ్రాండ్‌గా ఎదిగిన ఆసక్తికరమైన ప్రయాణం.",
      t1Year: "1975",
      t1Title: "ప్రారంభం 🌾",
      t1Desc: "ఎస్. వి. ఎన్. గుప్తా గారి నాయకత్వంలో బియ్యం వ్యాపారంలో కుటుంబ ప్రయాణం ప్రారంభమైంది.",
      t2Year: "నాయకత్వ మార్పు 🤝",
      t2Title: "నాయకత్వ పరివర్తన",
      t2Desc: "ఎస్. వి. వి. ఎస్. ఎన్. గుప్తా గారు కుటుంబ వారసత్వాన్ని ముందుకు తీసుకెళ్తూ వ్యాపారాన్ని విస్తరించారు మరియు ఆధునీకరించారు.",
      t3Year: "నేడు 🏢",
      t3Title: "గుప్తా ఎంటర్‌ప్రైజెస్",
      t3Desc: "వాసవి గోల్డ్ బ్రాండ్ కింద అత్యుత్తమ నాణ్యమైన బియ్యాన్ని అందిస్తూ గుప్తా ఎంటర్‌ప్రైజెస్‌గా నడుస్తోంది.",
      t4Year: "భవిష్యత్తు 🌍",
      t4Title: "విస్తరణ దృక్పథం",
      t4Desc: "నాణ్యమైన శ్రేష్ఠతను కొనసాగిస్తూ భారతదేశమంతటా మరియు అంతర్జాతీయ మార్కెట్లకు విస్తరించడం.",
    },
    whyChoose: {
      eyebrow: "వాసవి గోల్డ్ ఎందుకు?",
      title: "వ్యాపారులు & కుటుంబాలు",
      titleHighlight: "వాసవి గోల్డ్‌నే ఎందుకు ఎంచుకుంటారు?",
      subtitle: "మేము సంప్రదాయ నమ్మకంతో పాటు ఆధునిక గ్రేడింగ్ ప్రమాణాలను పాటిస్తాము.",
      c1Title: "అత్యుత్తమ నాణ్యత",
      c1Desc: "ప్రతి బ్యాచ్ జాగ్రత్తగా క్రమబద్ధీకరించబడి అత్యుత్తమ నాణ్యతా ప్రమాణాలకు అనుగుణంగా తయారు చేయబడుతుంది.",
      c2Title: "అందుబాటు ధరలు",
      c2Desc: "అదనపు ఛార్జీలు లేకుండా అత్యుత్తమ నాణ్యమైన బియ్యం న్యాయమైన ధరలలో లభిస్తాయి.",
      c3Title: "వేగవంతమైన డెలివరీ",
      c3Desc: "మీ దుకాణాలు మరియు వంటశాలలకు బియ్యం ఎల్లప్పుడూ లభించేలా సమయానికి సరఫరా చేస్తాము.",
      c4Title: "నిజాయితీతో కూడిన వ్యాపారం",
      c4Desc: "స్పష్టమైన వ్యాపార వ్యవహారాలు. మేము మాట ఇచ్చిన నాణ్యతనే మీకు అందిస్తాము.",
      c5Title: "విస్తృత రకాలు",
      c5Desc: "సోనా మసూరీ నుండి ఇడ్లీ బియ్యం వరకు — ప్రతి అవసరానికి ఒకే నమ్మకమైన ఆధారం.",
      c6Title: "వ్యక్తిగత పర్యవేక్షణ",
      c6Desc: "వినియోగదారులను పేరుపేరునా గురించిన కుటుంబ వ్యాపారం, నేరుగా ఉత్తమ సేవలు.",
      c7Title: "బలమైన డీలర్ నెట్‌వర్క్",
      c7Desc: "పరస్పర ఎదుగుదల మరియు నమ్మకంపై ఆధారపడిన సుదీర్ఘ భాగస్వామ్యాలు.",
    },
    products: {
      eyebrow: "మా ఉత్పత్తుల రకాలు",
      title: "ప్రతి ఇల్లు మరియు అవసరానికి",
      titleHighlight: "అత్యుత్తమ బియ్యం రకాలు.",
      lowGiName: "లో జిఐ రైస్ (డయాబెటిక్ ఫ్రెండ్లీ)",
      lowGiTag: "డయాబెటిక్ ఫ్రెండ్లీ · తక్కువ GI",
      lowGiDesc: "షుగర్ నియంత్రణకు మరియు ఆరోగ్యానికి అనువైన గుప్తాస్ వాసవి గోల్డ్ లో జిఐ (Low GI) తెలుపు బియ్యం. సహజ సువాసన, పాత బియ్యం రుచి మరియు అద్భుతమైన ఆరోగ్యం.",
      lowGiBadge: "డయాబెటిక్ కేర్ · 1కేజీ",
      riceRavvaName: "ప్రీమియం రైస్ రవ్వ",
      riceRavvaTag: "డబుల్ సిల్కీ & సోర్టెక్స్డ్",
      riceRavvaDesc: "గుప్తాస్ వాసవి గోల్డ్ ప్రీమియం రైస్ రవ్వ. ఉప్మా, కుడుములు మరియు పిండి వంటల కోసం డబుల్ సిల్కీ & అత్యుత్తమ సోర్టెక్స్డ్ రవ్వ.",
      bangaruName: "బంగారు తీగలు (గోల్డెన్ లాంగ్ రైస్)",
      bangaruTag: "కమ్మని రుచి & సువాసన · 26 కేజీ",
      bangaruDesc: "గుప్తా ఎంటర్‌ప్రైజెస్ వారి విజి రైస్ బంగారు తీగలు బియ్యం. కమ్మని రుచి, పరిమళించే సువాసన మరియు పొడవైన గింజలతో కూడిన ప్రీమియం క్వాలిటీ.",
      ayodhyaName: "అయోధ్య రాముడు సోర్టెక్స్ HMT రైస్",
      ayodhyaTag: "అయోధ్య గ్రేడ్ · 26 కేజీ",
      ayodhyaDesc: "గుప్తా ఎంటర్‌ప్రైజెస్ వారి అయోధ్య రాముడు సోర్టెక్స్ HMT బియ్యం. ప్రతి భోజనాన్ని సువాసనభరితంగా మరియు రుచికరంగా మార్చే నాణ్యమైన బియ్యం.",
      idlyRavvaName: "వాసవి గోల్డ్ ఇడ్లీ రవ్వ",
      idlyRavvaTag: "మెత్తని ఇడ్లీల కోసం · 26 కేజీ",
      idlyRavvaDesc: "గుప్తాస్ వాసవి గోల్డ్ ప్రీమియం ఇడ్లీ రవ్వ. 100% సహజమైనది, కృత్రిమ రంగులు లేనిది. మెత్తని, దూది వంటి ఇడ్లీల కోసం పరిపూర్ణమైన మిశ్రమం.",
      superiorSortexName: "వాసవి గోల్డ్ సోర్టెక్స్ సుపీరియర్ క్వాలిటీ రైస్ (బ్లూ ప్యాక్)",
      superiorSortexTag: "100% నాచురల్ సువాసన · 26 కేజీ",
      superiorSortexDesc: "గుప్తాస్ వాసవి గోల్డ్ సోర్టెక్స్ సుపీరియర్ క్వాలిటీ బియ్యం (రాయల్ బ్లూ ప్యాక్). 100% సహజ సువాసన, ఖచ్చితమైన స్వచ్ఛత మరియు కమ్మని రుచితో కూడిన 26 కేజీ బియ్యం.",
      greenSortexName: "వాసవి గోల్డ్ సోర్టెక్స్ సుపీరియర్ క్వాలిటీ రైస్ (గ్రీన్ ప్యాక్)",
      greenSortexTag: "100% నాచురల్ సువాసన · 26 కేజీ",
      greenSortexDesc: "గుప్తాస్ వాసవి గోల్డ్ సోర్టెక్స్ సుపీరియర్ క్వాలిటీ బియ్యం (ఐకానిక్ ఎమరాల్డ్ గ్రీన్ ప్యాక్). 100% సహజ సువాసన, ఖచ్చితమైన స్వచ్ఛత మరియు సాంప్రదాయ రుచితో కూడిన 26 కేజీ బియ్యం.",
      maroonSortexName: "వాసవి గోల్డ్ సోర్టెక్స్ సుపీరియర్ క్వాలిటీ రైస్ (మెరూన్ ప్యాక్)",
      maroonSortexTag: "100% నాచురల్ సువాసన · 26 కేజీ",
      maroonSortexDesc: "గుప్తాస్ వాసవి గోల్డ్ సోర్టెక్స్ సుపీరియర్ క్వాలిటీ బియ్యం (రిచ్ మెరూన్ ప్యాక్). 100% సహజ సువాసన, ఖచ్చితమైన స్వచ్ఛత మరియు విశిష్టమైన సాంప్రదాయ రుచితో కూడిన 26 కేజీ బియ్యం.",
      sonaName: "సోనా మసూరీ",
      sonaTag: "నిత్య వినియోగానికి శ్రేష్టం",
      sonaDesc: "తేలికైనది, సువాసనగలది మరియు సులభంగా జీర్ణమయ్యేది — దక్షిణ భారతదేశంలో అత్యంత ప్రజాదరణ పొందిన బియ్యం.",
      steamName: "స్టీమ్ రైస్ (ఉడకబెట్టిన బియ్యం)",
      steamTag: "మెత్తని & విడివిడి గింజలు",
      steamDesc: "ఆవిరిపై ప్రాసెస్ చేయబడిన బియ్యం, వండినప్పుడు విడివిడిగా, మెత్తగా మరియు రుచిగా ఉంటాయి.",
      rawName: "రా రైస్ (పచ్చి బియ్యం)",
      rawTag: "సహజమైన & ప్యూర్",
      rawDesc: "సహజమైన రుచి, సువాసన మరియు పోషక విలువలు కలిగిన స్వచ్ఛమైన పచ్చి బియ్యం.",
      premName: "ప్రీమియం రైస్",
      premTag: "సిగ్నేచర్ గ్రేడ్",
      premDesc: "ప్రత్యేకమైన వంటకాల కోసం జాగ్రత్తగా ఎంపిక చేసిన పొడవైన నాణ్యమైన బియ్యం.",
      idliName: "ఇడ్లీ రైస్",
      idliTag: "మెత్తని ఇడ్లీల కోసం",
      idliDesc: "ఇడ్లీ మరియు దోస పిండి కోసం ప్రత్యేకంగా తయారుచేసిన మెత్తని బియ్యం.",
      brokenName: "నూకలు (బ్రోకెన్ రైస్)",
      brokenTag: "పొదుపైన ఎంపిక",
      brokenDesc: "జావలు, పిండి వంటలు మరియు పెద్ద ఎత్తున వంటకాలకు అనువైన తక్కువ ధర బియ్యం నూకలు.",
      enquireBtn: "బల్క్ ఆర్డర్ కోసం విచారించండి",
    },
    markets: {
      eyebrow: "హోల్‌సేల్ & రిటైల్",
      title: "అన్ని రకాల వ్యాపార భాగస్వాములకు",
      titleHighlight: "బియ్యం సరఫరా.",
      subtitle: "ఒక్క బస్తా కొనుగోలుదారుల నుండి పెద్ద కంటైనర్ ఎగుమతిదారుల వరకు అందరికీ ఒకే రకమైన నిబద్ధతతో సేవలు అందిస్తున్నాము.",
      m1: "రిటైల్ షాపులు",
      m2: "డీలర్లు",
      m3: "డిస్ట్రిబ్యూటర్లు",
      m4: "సూపర్ మార్కెట్లు",
      m5: "హోటళ్లు & రెస్టారెంట్లు",
      m6: "ఎగుమతిదారులు (Export)",
      m7: "వ్యక్తిగత కస్టమర్లు",
    },
    stats: {
      eyebrow: "సంఖ్యలలో గుప్తా ఎంటర్‌ప్రైజెస్",
      title: "మా నిబద్ధతను చాటే",
      titleHighlight: "ముఖ్యమైన సంఖ్యలు.",
      s1Label: "సంవత్సరాల సుదీర్ఘ చరిత్ర",
      s2Label: "బియ్యం ఉత్పత్తుల రకాలు",
      s3Label: "సంతోషకర వ్యాపార భాగస్వాములు",
      s4Label: "పెరుగుతున్న కస్టమర్ల సంఖ్య",
    },
    mission: {
      eyebrow: "లక్ష్యం & దృక్పథం",
      missionTitle: "మా లక్ష్యం (Mission)",
      missionDesc: "అత్యుత్తమ నాణ్యత, నిజాయితీతో కూడిన వ్యాపార వ్యవహారాలు మరియు శ్రేష్ఠతతో శాశ్వతమైన వ్యాపార సంబంధాలను నిర్మించడం.",
      visionTitle: "మా దృక్పథం (Vision)",
      visionDesc: "మా నాణ్యమైన సంప్రదాయాన్ని కొనసాగిస్తూ వాసవి గోల్డ్‌ను భారతదేశంలో మరియు అంతర్జాతీయ మార్కెట్లలో విశ్వసనీయ బ్రాండ్‌గా నిలపడం.",
    },
    manifesto: {
      eyebrow: "బ్రాండ్ ప్రతిజ్ఞ",
      title: "వాసవి గోల్డ్ నమ్మకమైన హామీ",
      m1Title: "ప్రతి బియ్యపు గింజపై శ్రద్ధ.",
      m1Desc: "మేము బియ్యాన్ని భోజనంలో అత్యంత ముఖ్యమైనదిగా భావిస్తాము — సొంత కుటుంబానికి వడ్డించినట్లే ప్రతి బ్యాచ్‌ను ప్యాకింగ్ చేస్తాము.",
      m2Title: "రోజువారీగా సంపాదించుకున్న నమ్మకం.",
      m2Desc: "స్థిరమైన నాణ్యతే మా పనితనం. ఈ రోజు మీరు పొందే నాణ్యతే వచ్చే సీజన్‌లో కూడా లభిస్తుంది.",
      m3Title: "తరతరాల సంప్రదాయం.",
      m3Desc: "ఎస్. వి. ఎన్. గుప్తా గారి నుండి ఎస్. వి. వి. ఎస్. ఎన్. గుప్తా గారి వరకు, వాసవి గోల్డ్ 50 ఏళ్లకు పైగా కుటుంబ నిబద్ధతకు ప్రతీక.",
    },
    values: {
      eyebrow: "ముఖ్య విలువలు",
      title: "మా ప్రతి అడుగును నడిపించే",
      titleHighlight: "ముఖ్య సూత్రాలు.",
      v1Title: "నిజాయితీ (Integrity)",
      v1Desc: "మేము ఎల్లప్పుడూ నిజాయితీతో వ్యాపారం చేస్తాము.",
      v2Title: "నాణ్యత (Quality)",
      v2Desc: "ప్రతి బ్యాచ్‌లోనూ అత్యుత్తమ గ్రేడ్ బియ్యం.",
      v3Title: "నమ్మకం (Trust)",
      v3Desc: "తరతరాలు నిలిచిపోయే వ్యాపార అనుబంధాలు.",
      v4Title: "కస్టమర్ సంతృప్తి (Satisfaction)",
      v4Desc: "మీ వంటగది నాణ్యతే మా మొదటి ప్రాధాన్యత.",
      v5Title: "అభివృద్ధి (Growth)",
      v5Desc: "మా భాగస్వాములతో కలిసి వృద్ధి చెందడం.",
      v6Title: "ఆవిష్కరణ (Innovation)",
      v6Desc: "మెరుగైన సేకరణ మరియు ఆధునిక సేవలు.",
    },
    faq: {
      eyebrow: "తరచుగా అడిగే ప్రశ్నలు",
      title: "సందేహాలు ఉన్నాయా?",
      titleHighlight: "మా సమాధానాలు ఇక్కడ ఉన్నాయి.",
      subtitle: "కొనుగోలు, బల్క్ ఆర్డర్లు మరియు డీలర్‌షిప్ గురించి మీరు తెలుసుకోవాల్సినవన్నీ.",
      q1: "మీరు ఏయే రకాల బియ్యాన్ని పంపిణీ చేస్తారు?",
      a1: "వాసవి గోల్డ్ బ్రాండ్ కింద మేము సోనా మసూరీ, స్టీమ్ రైస్, రా రైస్, ప్రీమియం రైస్, ఇడ్లీ రైస్ మరియు బియ్యం నూకలను విక్రయిస్తాము.",
      q2: "మీరు బల్క్ ఆర్డర్లు (పెద్ద మొత్తంలో) సరఫరా చేస్తారా?",
      a2: "అవును. రిటైలర్లు, డిస్ట్రిబ్యూటర్లు, సూపర్ మార్కెట్లు, హోటళ్లు మరియు రెస్టారెంట్లకు బల్క్ సరఫరాలో మేము ప్రత్యేకత కలిగి ఉన్నాము.",
      q3: "డీలర్లు మిమ్మల్ని ఎలా సంప్రదించాలి?",
      a3: "డీలర్లు నేరుగా వాట్సాప్ లేదా ఫోన్ ద్వారా లేదా క్రింది విచారణ ఫారమ్ ద్వారా మమ్మల్ని సంప్రదించవచ్చు.",
      q4: "మీరు అంతర్జాతీయ ఎగుమతులకు (Export) సపోర్ట్ చేస్తారా?",
      a4: "ఖచ్చితంగా. మేము ఎగుమతి కొనుగోలుదారులను స్వాగతిస్తున్నాము మరియు ప్రపంచ మార్కెట్లకు విస్తరిస్తున్నాము.",
      q5: "వ్యాపారులు ధరల వివరాలు (Quotation) కోరవచ్చా?",
      a5: "అవును. ఫారమ్ లేదా వాట్సాప్ ద్వారా మీ అవసరమైన రకం మరియు పరిమాణాన్ని తెలియజేస్తే ఉత్తమ ధరలను పంపుతాము.",
    },
    contact: {
      eyebrow: "వ్యాపార విచారణ",
      title: "రండు, కలసి పటిష్టమైన",
      titleHighlight: "వ్యాపారాన్ని నిర్మిద్దాం.",
      subtitle: "డీలర్లు, డిస్ట్రిబ్యూటర్లు, బల్క్ కొనుగోలుదారులు మరియు ఎగుమతి దారులు — మమ్మల్ని సంప్రదించండి, మా బృందం వెంటనే స్పందిస్తుంది.",
      visitUs: "మా చిరునామా",
      callUs: "ఫోన్ చేయండి",
      emailUs: "ఇమెయిల్ చేయండి",
      chatWhatsapp: "వాట్సాప్‌లో చాట్ చేయండి",
      formTitle: "మీ విచారణ పంపండి",
      formSubtitle: "మేము సాధారణంగా ఒక పని దినంలో స్పందిస్తాము.",
      nameLabel: "పూర్తి పేరు *",
      namePlaceholder: "మీ పేరు",
      phoneLabel: "ఫోన్ నంబర్ *",
      phonePlaceholder: "+91 ...",
      emailLabel: "ఇమెయిల్ *",
      emailPlaceholder: "you@email.com",
      companyLabel: "సంస్థ / కంపెనీ పేరు (ఐచ్ఛికం)",
      companyPlaceholder: "మీ వ్యాపారం పేరు",
      typeLabel: "విచారణ రకం",
      msgLabel: "సందేశం *",
      msgPlaceholder: "మీకు అవసరమైన బియ్యం రకం, పరిమాణం మరియు లొకేషన్ వివరాలు తెలుపండి.",
      submitBtn: "విచారణ పంపండి",
      submittingBtn: "పంపుతోంది…",
      submittedBtn: "విచారణ పంపబడింది",
    },
    footer: {
      brandDesc: "ఎస్. వి. ఎన్. గుప్తా గారు 1975లో స్థాపించిన 50 ఏళ్ల పటిష్టమైన సంప్రదాయాన్ని ఎస్. వి. వి. ఎస్. ఎన్. గుప్తా గారు గుప్తా ఎంటర్‌ప్రైజెస్‌గా తీర్చిదిద్ది వాసవి గోల్డ్ ప్రీమియం బియ్యాన్ని నమ్మకంతో అందిస్తున్నారు.",
      quickLinks: "ముఖ్యమైన లింకులు",
      contactTitle: "సంప్రదించాల్సిన వివరాలు",
      rights: "అన్ని హక్కులు ప్రత్యేకించబడ్డాయి.",
      address: "చెముడులంక, డాక్టర్ బి. ఆర్. అంబేద్కర్ కోనసీమ జిల్లా, ఆంధ్రప్రదేశ్ 533234",
    },
  },
};
